import { openDB } from 'idb';

const DB_NAME = 'soumisspro-db';
const DB_VERSION = 3;

export async function getDB() {
  return openDB(DB_NAME, DB_VERSION, {
    upgrade(db, oldVersion) {
      if (!db.objectStoreNames.contains('submissions')) {
        const s = db.createObjectStore('submissions', { keyPath: 'id' });
        s.createIndex('user_id', 'user_id');
        s.createIndex('updated_at', 'updated_at');
        s.createIndex('synced', 'synced');
      }
      if (!db.objectStoreNames.contains('clients')) {
        const c = db.createObjectStore('clients', { keyPath: 'id' });
        c.createIndex('user_id', 'user_id');
        c.createIndex('synced', 'synced');
      }
      if (!db.objectStoreNames.contains('profiles')) {
        db.createObjectStore('profiles', { keyPath: 'user_id' });
      }
      if (!db.objectStoreNames.contains('meta')) {
        db.createObjectStore('meta', { keyPath: 'key' });
      }
      // v2: reusable quote templates
      if (oldVersion < 2 && !db.objectStoreNames.contains('templates')) {
        const tpl = db.createObjectStore('templates', { keyPath: 'id' });
        tpl.createIndex('user_id', 'user_id');
        tpl.createIndex('updated_at', 'updated_at');
        tpl.createIndex('synced', 'synced');
      }
      // v3: client invoices (converted from accepted submissions)
      if (oldVersion < 3 && !db.objectStoreNames.contains('invoices')) {
        const inv = db.createObjectStore('invoices', { keyPath: 'id' });
        inv.createIndex('user_id', 'user_id');
        inv.createIndex('updated_at', 'updated_at');
        inv.createIndex('synced', 'synced');
        inv.createIndex('source_submission_id', 'source_submission_id');
      }
    },
  });
}

export async function putItem(store, item) {
  try {
    const db = await getDB();
    await db.put(store, item);
    return true;
  } catch (e) {
    console.error('IDB put error', e);
    return false;
  }
}

export async function getAll(store, userId) {
  try {
    const db = await getDB();
    const all = await db.getAll(store);
    return userId ? all.filter(i => i.user_id === userId) : all;
  } catch (e) {
    console.error('IDB getAll error', e);
    return [];
  }
}

export async function getItem(store, id) {
  try {
    const db = await getDB();
    return await db.get(store, id);
  } catch (e) {
    console.error('IDB get error', e);
    return null;
  }
}

export async function deleteItem(store, id) {
  try {
    const db = await getDB();
    await db.delete(store, id);
    return true;
  } catch (e) {
    console.error('IDB delete error', e);
    return false;
  }
}

export async function getUnsynced(store) {
  try {
    const db = await getDB();
    const all = await db.getAll(store);
    return all.filter(i => i.synced === false);
  } catch (e) {
    return [];
  }
}

/**
 * Wipes ALL local IndexedDB data (submissions, clients, templates, profiles, meta).
 * Used when a user joins a team / changes effective_owner_id so they don't see
 * stale data from their previous account state.
 */
export async function clearAllData() {
  try {
    const db = await getDB();
    const stores = ['submissions', 'clients', 'templates', 'invoices', 'profiles', 'meta'];
    await Promise.all(
      stores
        .filter((s) => db.objectStoreNames.contains(s))
        .map((s) => db.clear(s))
    );
    return true;
  } catch (e) {
    console.error('IDB clearAllData error', e);
    return false;
  }
}
